/**
 * Runtime configuration helper.
 *
 * In production, `window.APP_CONFIG` is populated by /config.js which is
 * generated at container start-up by confd from the environment.
 *
 * Two deployment modes are supported:
 *
 *  Multi-domain  – frontend on https://ste-emulator-stage.spireon.com/
 *                  backend  on https://api-ste-emulator-stage.spireon.com/
 *                  → API_BASE_URL = "https://api-ste-emulator-stage.spireon.com"
 *
 *  Single-domain – both on https://myapp.com, backend under /api
 *                  → API_BASE_URL = ""   (nginx rewrites /api/* → backend)
 *
 * For local development the CRA proxy (package.json "proxy") handles the
 * forwarding, so API_BASE_URL stays "" and every fetch just uses a relative
 * path.
 */

const cfg = (typeof window !== 'undefined' && window.APP_CONFIG) || {};

/**
 * Base URL for all backend API calls.
 * Never has a trailing slash.
 */
export const API_BASE_URL =
    (cfg.API_BASE_URL || process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

/**
 * Returns the URL prefix that should be prepended to every API path.
 *
 * Multi-domain:  "https://api-ste-emulator-stage.spireon.com"
 * Single-domain: "/api"   (nginx strips the prefix before forwarding)
 * Local dev:     ""       (CRA proxy handles forwarding)
 */
export const API_PREFIX = API_BASE_URL || (cfg.USE_API_PREFIX === 'true' ? '/api' : '');
